<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm($event)"
  (cancel)="cancel()"
  data-test="copy-templates-by-year-dialog"
>
  <div class="flex--container">
    <!-- Source crop year select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'fromCropYear' | translate }}</mat-label>
        <mat-select formControlName="sourceYear" data-test="copy-templates-crop-source-year">
          @for (cropYear of data.cropYears; track cropYear) {
            <mat-option [value]="cropYear" data-test="copy-templates-source-year-options">
              {{ cropYear }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Destination crop year select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'toCropYear' | translate }}</mat-label>
        <mat-select
          formControlName="destinationYear"
          data-test="copy-templates-crop-destination-year"
        >
          @for (cropYear of data.cropYears; track cropYear) {
            <mat-option [value]="cropYear" data-test="copy-templates-destination-year-options">
              {{ cropYear }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    @if (formGroup.errors?.yearInvalid && (formGroup.touched || formGroup.dirty)) {
      <div class="cross-validation-error-message alert alert-danger">
        {{ 'copyTemplateYearInvalid' | translate }}
      </div>
    }
  </div>
</agr-form-dialog>
